import React, { useEffect, useRef, useState } from "react"
import DataTable from "react-data-table-component"
import { ChevronLeft, ChevronRight, Edit, Trash } from "react-feather"
import ReactPaginate from "react-paginate"
import classNames from "classnames"

import "../../assets/scss/plugins/extensions/react-paginate.scss"
import "../../assets/scss/pages/data-list.scss"
import fetchApi from "../../utility/context/fetchApi"
import { connect } from "react-redux"
import { promocodeSelector, tokenSelector } from "../../redux/selectors"
import DataListSidebar from "./PromocodeDataListSidebar"
import { CustomHeader, getSliceData, getSortIndex, getTotalPages, typeNumber, typeString } from "./utils"
import { setPromocode } from "../../redux/actions"
import BasicSweetCallback from "../../extensions/sweet-alert/SweetAlertCallback"

const ActionsComponent = ({ row, editRow, deleteRow }) => {
    return (
        <div className="data-list-action minus-6">
            <Edit
                className="cursor-pointer control-icon"
                size={20}
                onClick={() => {
                    return editRow(row)
                }}
            />
            <Trash
                className="cursor-pointer control-icon"
                size={20}
                onClick={() => {
                    deleteRow(row)
                }}
            />
        </div>
    )
}

function Promocode(props) {
    const [data, setData] = useState([])
    const [total, setTotal] = useState(1)
    const [page, setPage] = useState(0)
    const [limit, setLimit] = useState(4)
    const [totalPages, setTotalPages] = useState(1)
    const [sortIndex, setSortIndex] = useState([1, 2])
    const [sidebar, setSidebar] = useState(false)
    const [currentData, setCurrentData] = useState(null)
    const [filter, setFilter] = useState('')

    useEffect(() => {
        if (filter) {
            const filteredData = props.totalData.filter(({ name }) => name.toLowerCase().includes(filter.toLowerCase()))
            setData(filteredData)
            setTotal(filteredData.length)
            setTotalPages(1)
            setPage(0)
            setSortIndex([1, filteredData.length])
        } else {
            setData(getSliceData(props.totalData, page, limit))
            setTotal(props.totalData.length)
            setTotalPages(getTotalPages(props.totalData, limit))
            setSortIndex(getSortIndex(page, limit, props.totalData.length))
        }
    }, [page, props.totalData, limit, filter, props.token])

    const handleLimit = (limit) => {
        setPage(0)
        setLimit(limit)
    }

    const cancelSidebar = () => {
        setSidebar(false)
        setCurrentData(null)
    }

    const addData = (data) => {
        fetchApi({
            url: '/promocode',
            method: 'POST',
            token: props.token,
            body: data
        }).then((doc) => {
            props.setPromocode([doc, ...props.totalData])
            setPage(0)
            setCurrentData(null)
        })
    }

    const updateData = ({ _id, ...data }) => {
        fetchApi({
            url: `/promocode/${_id}`,
            method: 'PATCH',
            token: props.token,
            body: data
        }).then((res) => {
            props.setPromocode(props.totalData.map((node) => {
                if (node._id === res._id) return res
                return node
            }))
            setCurrentData(null)
        })
    }

    const removeData = ({ _id }) => {
        fetchApi({
            url: `/promocode/${_id}`,
            method: 'DELETE',
            token: props.token,
        }).then(() => {
            props.setPromocode(props.totalData.filter((node) =>
                node._id !== _id
            ))
        })
    }

    const columns = [
        {
            name: "Name",
            selector: "name",
            grow: 1,
            type: typeString,
            sortable: true
        },
        {
            name: "Discount",
            type: typeNumber,
            selector: "discount",
            grow: 1,
            sortable: true
        },
        {
            name: "Count",
            type: typeNumber,
            selector: "count",
            grow: 1,
            sortable: true
        },
        {
            name: "Actions",
            width: '100px',
            cell: row => (
                <ActionsComponent
                    row={row}
                    editRow={(row) => {
                        setCurrentData(row)
                        setSidebar(true)
                    }}
                    deleteRow={(row) => refAlert.current.show(row)}
                />
            )
        }
    ]
    const refAlert = useRef()

    return <div className={`data-list list-view`}>
        <BasicSweetCallback refAlert={refAlert}  onConfirm={(row) => {
                    removeData(row)
                }}/>
        <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationComponent={() => (
                <ReactPaginate
                    previousLabel={<ChevronLeft size={15} />}
                    nextLabel={<ChevronRight size={15} />}
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages}
                    containerClassName="vx-pagination separated-pagination pagination-end pagination-sm mb-0 mt-2"
                    activeClassName="active"
                    initialPage={page}
                    onPageChange={page => setPage(page.selected)}
                />
            )}
            noHeader
            subHeader
            responsive
            pointerOnHover
            subHeaderComponent={
                <CustomHeader
                    handleSidebar={setSidebar}
                    handleFilter={(value) => setFilter(value)}
                    handleRowsPerPage={handleLimit}
                    rowsPerPage={limit}
                    total={total}
                    index={sortIndex}
                />
            }
        />
        <DataListSidebar
            show={sidebar}
            data={currentData}
            updateData={updateData}
            addData={addData}
            cancelSidebar={cancelSidebar}
        />
        <div
            className={classNames("data-list-overlay", {
                show: sidebar
            })}
            onClick={cancelSidebar}
        />
    </div>
}

const mapStateToProps = state => {
    return {
        totalData: promocodeSelector(state),
        token: tokenSelector(state)
    }
}

export default connect(mapStateToProps, { setPromocode })(Promocode)
